// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Router from './router'
import Store from './store'
import utils from 'inomph-common'
import cart from './assets/js/cart-service'
import Snackbar from 'node-snackbar'
import VueMeta from 'vue-meta'
import * as axios from 'axios'
import VeeValidate from 'vee-validate'

import VueSweetalert2 from 'vue-sweetalert2'

// import VueMaterial from 'vue-material'
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
// import VTooltip from 'v-tooltip'
import VueCollapse from 'vue2-collapse'
import VueTheMask from 'vue-the-mask'
import Tooltip from 'vue-directive-tooltip'
// import 'vue-directive-tooltip/css/index.css'
import VueModalStore from 'vue-modal/dist/vue-modal-store'
import VuePaginate from 'vue-paginate'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import colors from 'vuetify/es5/util/colors'

Vue.use(Tooltip)
Vue.use(VueModalStore)

Vue.use(VueTheMask)
Vue.use(VueCollapse)
// Vue.use(VTooltip)
// Vue.use(VueMaterial)
Vue.use(VueFormWizard)
Vue.use(VueSweetalert2)
Vue.use(VuePaginate)
const store = Store(process.env)
const router = Router(store)

Vue.use(Vuetify, {
  theme: {
    primary: colors.purple,
    secondary: colors.grey.darken1,
    accent: colors.shades.black,
    error: colors.red.accent3
  }
})
Vue.use(VueMeta, {
  keyName: 'meta'
})
Vue.use(VeeValidate)

require('jquery')
require('materialize-css')
// require('materialize-css/dist/css/materialize.min.css')
require('materialize-stepper')
require('materialize-stepper/materialize-stepper.min.css')

Snackbar.error = function (errorMessage) {
  this.show({
    text: errorMessage,
    actionText: 'Got it',
    pos: 'bottom-right',
    showAction: true,
    textColor: '#FFF',
    actionTextColor: '#d3d3d3',
    backgroundColor: '#B03236',
    customClass: 'fast',
    duration: 5000
  })
}

Snackbar.success = function (successMessage) {
  this.show({
    text: successMessage,
    pos: 'bottom-right',
    showAction: false,
    textColor: '#FFF',
    backgroundColor: '#039403',
    customClass: 'fast',
    duration: 2000
  })
}

Object.defineProperty(Vue.prototype, '$utils', { value: utils })
Object.defineProperty(Vue.prototype, '$cart', { value: cart })
Object.defineProperty(Vue.prototype, '$snackbar', { value: Snackbar })
Object.defineProperty(Vue.prototype, '$config', { value: process.env })
Object.defineProperty(Vue.prototype, '$http', { value: axios })

/* eslint-disable no-undef, no-undef */
Object.defineProperty(Vue.prototype, '$M', { value: M })

Vue.config.productionTip = false

/* eslint-disable no-undef, no-new */
// disable for demo
FB.init({
  appId: process.env.FB_APP_ID, // dev
  version: 'v2.7' // or v2.1, v2.2, v2.3, ...
})

new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  vuetify: new Vuetify(),
  // render: h => h(App),
  store: store
})



// WEBPACK FOOTER //
// ./src/main.js